import React from 'react'
import pic01 from '../assets/images/pic01.svg'
import { Link as ScrollLink } from 'react-scroll'

const Banner = props => (
  <section id="home">
    <div className="content">
      <header>
        <h2>The future has landed</h2>
        <p>
          And there are no hoverboards or flying cars.
          <br />
          Just apps. Lots of mother flipping apps.
        </p>
      </header>
      <span className="image">
        <img src={pic01} alt="intro" />
      </span>
    </div>
    <ScrollLink
      to="one"
      className="goto-next"
      activeClass="active"
      smooth={true}
      offset={50}
      duration={1500}
      spy={true}
    >
      Next
    </ScrollLink>
  </section>
)

export default Banner
